var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVDrm02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_82154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1006 16.8416C33.2862 15.7859 32.9713 14.6595 32.1559 13.844C30.8274 12.5155 28.6735 12.5155 27.345 13.844C26.0165 15.1726 26.0165 17.3264 27.345 18.6549C28.1604 19.4703 29.2869 19.7852 30.3426 19.5996",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7505 24.9046C34.5305 24.9046 38.4054 21.0296 38.4054 16.2496C38.4054 11.4697 34.5305 7.59473 29.7505 7.59473C24.9705 7.59473 21.0956 11.4697 21.0956 16.2496C21.0956 21.0296 24.9705 24.9046 29.7505 24.9046Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2877 5.71233C34.4681 -0.107234 25.0328 -0.107234 19.2133 5.71233C14.5963 10.3293 13.6423 17.2223 16.3513 22.7799L1.34766 37.7834V44.6524H8.2166L10.8092 42.0597L11.035 38.9001L14.1946 38.6743L16.1405 36.7285L16.3663 33.5689L19.5259 33.3431L23.22 29.649C28.7776 32.3579 35.6705 31.404 40.2876 26.7869C46.1073 20.9672 46.1073 11.5319 40.2877 5.71233Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_82154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDrm02);
export default __webpack_public_path__ + "static/media/vDRM02.3d6eb14f9218d5a7b5f50af793e62b00.svg";
export { ForwardRef as ReactComponent };